import { useState, useEffect } from "react";
import { IEquipmentSelectorProps } from "./EquipmentSelector.props";
import { EQUIPMENT_TYPE } from "@store/Equipments/actionTypes";

interface IPoolSelectorControl {
  readonly open: boolean;
  readonly value: EQUIPMENT_TYPE;

  onOpen(): void;
  onSelect(v?: EQUIPMENT_TYPE): void;
}

export const useEquipmentSelectorControl = (
  props: IEquipmentSelectorProps
): IPoolSelectorControl => {
  const [open, setOpen] = useState<boolean>(false);
  const [value, setValue] = useState<EQUIPMENT_TYPE>(props.options[0]);
  const onOpen = () => setOpen((prev) => !prev);

  const onSelect = (eq: EQUIPMENT_TYPE) => {
    setOpen(false);
    setValue(eq);
  };

  useEffect(() => {
    if (!open) return;

    const clear = () => {
      setOpen(false);
    };
    const exitEvent = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setOpen(false);
      }
    };
    document.body.addEventListener("click", clear);
    document.body.addEventListener("keydown", exitEvent);

    return () => {
      document.body.removeEventListener("click", clear);
      document.body.removeEventListener("keydown", exitEvent);
    };
  }, [open]);
  return {
    open,
    value,

    onOpen,
    onSelect,
  };
};
